import { useTranslation } from 'react-i18next'

export const useSortingFilters = () => {
	const { t } = useTranslation()

	const sortingFilters = {
		id: 'ordering',
		options: [
			{
				value: 'created',
				label: `${t('Created')} asc`
			},
			{
				value: '-created',
				label: `${t('Created')} desc`
			},
			{
				value: 'quantity',
				label: `${t('Quantity')} asc`
			},
			{
				value: '-quantity',
				label: `${t('Quantity')} desc`
			},
			{
				value: 'category',
				label: `${t('Category')} asc`
			},
			{
				value: '-category',
				label: `${t('Category')} desc`
			},
			{
				value: 'product',
				label: `${t('Product')} asc`
			},
			{
				value: '-product',
				label: `${t('Product')} desc`
			},
			{
				value: 'product__name',
				label: `${t('Product name')} asc`
			},
			{
				value: '-product__name',
				label: `${t('Product name')} desc`
			},
			{
				value: 'product__category',
				label: `${t('Product category')} asc`
			},
			{
				value: '-product__category',
				label: `${t('Product category')} desc`
			},
			{
				value: 'booking__booth',
				label: `${t('Booking')} asc`
			},
			{
				value: '-booking__booth',
				label: `${t('Booking')} desc`
			}
		]
	}

	return sortingFilters
}
